<template>
    <tree-list-card
        id="ai-reg-grid"
        ref="treeListInstance"
        :key-expr="keyExpr"
        :cardName="cardName"
        :view-name="viewName"
        :db-schema="dbSchema"
        :db-source="dbSource"
        :api="apiGetList"
        :toolbar-meta="toolbarMeta"
        :context-menu-meta="contextMenuMeta"
        :custom-context-menu="customContextMenu"
    >
        <template v-for="(_, slot) in $slots" #[slot]>
            <slot :name="slot"/>
        </template>
    </tree-list-card>
</template>

<script>
export default {
    name: 'view-kv-customer',
};
</script>

<script setup>
import {defineProps, ref} from 'vue';
import treeListCard from '@/components/tree-list-card-component/tree-list-card.vue';

defineProps({
    dbSchema: String,
    dbSource: String,
    keyExpr: String,
    apiGetList: String,
    viewName: String,
    cardName: String,
    toolbarMeta: Object,
    contextMenuMeta: Array,
    customContextMenu: Array,
});
const treeListInstance = ref();
defineExpose({
    treeListInstance
});
</script>
<style>
#ai-reg-grid {
    height: 100%;
}
</style>
